import { PropTypes } from 'prop-types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const SpanMetaField = ({
  defaultValue,
  label,
  metadata,
  minLength,
  maxLength,
  name,
  placeholder,
  pattern,
  tabIndex,
  className,
}) => {
  const { t } = useTranslation(['tasks']);
  const { readOnly, required } = metadata;
  const { control } = useFormContext();
  const rules = {
    required: required,
    validate: (value) => {
      const trimmedValue = value.trim();
      if (minLength && trimmedValue.length > 0 && trimmedValue.length < minLength) {
        return t('form.invalid_value');
      }

      if (pattern && value.length) {
        try {
          const re = new RegExp(pattern);
          return re.test(value) || t('form.invalid_value');
        } catch (e) {
          console.error(e);
        }
      }

      return required ? !!trimmedValue : !required;
    },
  };

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name={name}
      rules={rules}
      render={({ value }) => {
        return (
          <span
            className={className}
            disabled={readOnly}
            id={name}
            label={label}
            minLength={minLength}
            maxLength={maxLength}
            placeholder={placeholder}
            required={required}
            tabIndex={tabIndex}
            type="text"
          >
            {value}
          </span>
        );
      }}
    />
  );
};

SpanMetaField.propTypes = {
  defaultValue: PropTypes.string,
  label: PropTypes.string,
  mask: PropTypes.string,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  metadata: PropTypes.instanceOf(Object).isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  pattern: PropTypes.string,
  tabIndex: PropTypes.number,
  className: PropTypes.string,
};

SpanMetaField.defaultProps = {
  defaultValue: '',
  label: '',
  mask: null,
  minLength: null,
  maxLength: null,
  placeholder: '',
  pattern: null,
  tabIndex: null,
};
